import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        modalContent: {
            margin: remCalc(16),
            maxWidth: remCalc(598),
            maxHeight: '96vh',
            overflowY: 'auto',
            bg: 'background.base.default',
            borderRadius: 'large-1',
        },
        modalHeader: {
            display: 'flex',
            justifyContent: 'space-between',
            p: `${remCalc(40)} ${remCalc(24)} ${remCalc(32)}`,
        },
        modalTitle: {
            color: 'foreground.neutral.default',
        },
        modalDescription: {
            color: 'foreground.neutral.muted',
        },
        addressLabel: {
            color: 'foreground.neutral.muted',
        },
        editInfoText: {
            color: 'foreground.neutral.muted',
        },
        modalBody: {
            p: `${remCalc(0)} ${remCalc(24)} ${remCalc(40)}`,
        },
        radioGroupContainer: {
            display: 'flex',
            flexDirection: 'column',
            my: remCalc(24),
            gap: remCalc(24),
        },
        addressContainer: {
            display: 'flex',
            flexDirection: 'column',
            gap: remCalc(24),
        },
        buttonContainer: {
            display: 'flex',
            mt: remCalc(32),
            gap: {base: remCalc(8), lg: remCalc(16)},
            flexDirection: {base: 'column-reverse', lg: 'row'},
        },
    },
    variants: {
        inline: {
            modalHeader: {
                p: `0 0 ${remCalc(32)}`,
            },
            modalBody: {
                p: 0,
            },
        },
    },
}
